import {CustomRequest} from '../Custom';

export const put_lang = async (props, body) => {
    const {access, auth} = props.data;

    var user_id = access?.userId ?? auth?.access?.userId;
    const request = new CustomRequest('PUT', `users/${user_id}`, JSON.stringify(body), props);
    var res = await request.action();
    return res;
}